import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import { useGetInvoiceAuditLog } from "api/queries/invoice/useGetInvoiceAuditLog";
import Badge from "components/atoms/Badge/Badge";
import CardNew from "components/molecules/Card/CardNew";
import { InvoiceStatusColors } from "constants";
import { DateTimeFormat } from "helpers/dateTimeHelper";
import { useFormatPreferredDatetime } from "hooks/useFormatPreferredDatetime";

const initialAuditLogData = [];
function AuditLog({ invoiceId, className }) {
  const { formatPreferredDatetime } = useFormatPreferredDatetime(DateTimeFormat.fullDateTimeFormat);
  const { data: auditLog = initialAuditLogData, isLoading } = useGetInvoiceAuditLog({
    invoiceId,
    options: { enabled: !!invoiceId },
  });

  return (
    <CardNew
      isLoading={isLoading}
      title={<FormattedMessage id="billing.auditLog" defaultMessage="Audit Log" />}
      className={className}
    >
      <CardNew.Body className="overflow-auto p-0" style={{ maxHeight: "170px", overflowY: "scroll" }}>
        {auditLog && (
          <ul>
            {auditLog.map(({ time_created, action, name, comment }, i) => (
              <li
                key={`${time_created}-${action}-${name}-${comment}`}
                className={`border-1 border-grey pl-0 pr-0 pb-11 ${auditLog.length - 1 === i ? "" : "border-bottom"} ${
                  i === 0 ? "" : "pt-15 "
                }`}
              >
                <section className="d-flex justify-content-between mb-0 font-b3">
                  <span> {comment ? <p>{comment}</p> : <p>No comment</p>}</span>
                  <div className="d-flex align-items-center ml-2 font-b4">
                    <Badge
                      label={action}
                      type={
                        InvoiceStatusColors[action.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())] ||
                        "secondary"
                      }
                    />
                  </div>
                </section>
                <section className="d-flex justify-content-between mb-0 mt-2 font-b3">
                  <span className="text-secondary">{name}</span>
                  <div className="d-flex align-items-center ml-2">
                    <span className="text-secondary">{formatPreferredDatetime(time_created)}</span>
                  </div>
                </section>
              </li>
            ))}
          </ul>
        )}
      </CardNew.Body>
    </CardNew>
  );
}

AuditLog.propTypes = {
  invoiceId: PropTypes.string,
  className: PropTypes.string,
};

AuditLog.defaultProps = {
  invoiceId: undefined,
  className: "",
};

export default AuditLog;
